/**
 * Celebrations — UI-5 / TD-V2-AUTO-21.
 *
 * Listener client-side que dispara confete + toast quando notification do
 * tipo 'celebracao' chega via polling do `useNotifications`. Mantém estado
 * "última celebração vista" em memória (sem localStorage — fonte de verdade
 * é o backend) pra não disparar repetidamente.
 *
 * Preferência opt-in/out vive na matriz canônica (notification-preferences):
 * canal in-app é sempre on, mas o usuário pode desativar 'celebracao' globalmente
 * via `celebracoesDesligadasGlobal` (LocalStorage só pra preferência UX —
 * regra "zero localStorage de dados de negócio" NÃO inclui prefs cosméticas).
 *
 * Trade-off do localStorage aqui: confete é puramente visual — não é dado
 * de negócio (a notification in-app continua aparecendo). Persistir só
 * "quer ver confete?" via localStorage não viola a regra.
 */

import confetti from 'canvas-confetti';

const LOCAL_KEY = 'igm_celebracoes_off';

export function isCelebracoesEnabled(): boolean {
  try {
    return localStorage.getItem(LOCAL_KEY) !== '1';
  } catch {
    return true;
  }
}

export function setCelebracoesEnabled(enabled: boolean): void {
  try {
    if (enabled) {
      localStorage.removeItem(LOCAL_KEY);
    } else {
      localStorage.setItem(LOCAL_KEY, '1');
    }
  } catch {
    // Ignora — alguns browsers em modo privado bloqueiam
  }
}

/**
 * Dispara o efeito visual de confete. Versão "escopo padrão": 3 bursts
 * laterais com leve delay. Sai pelos cantos pra não tampar conteúdo central.
 *
 * No-op se a preferência local estiver desligada.
 */
export function fireConfetti(): void {
  if (!isCelebracoesEnabled()) return;
  if (typeof window === 'undefined') return;
  try {
    // Burst central
    confetti({
      particleCount: 80,
      spread: 70,
      origin: { y: 0.7 },
    });
    // Bursts laterais com delay (efeito de "explosão" continuada)
    window.setTimeout(() => {
      confetti({
        particleCount: 60,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.7 },
      });
    }, 200);
    window.setTimeout(() => {
      confetti({
        particleCount: 60,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.7 },
      });
    }, 400);
  } catch {
    // canvas-confetti pode falhar em SSR ou browsers antigos — degrada silenciosamente
  }
}
